"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTree = void 0;
const tree_1 = require("../../../components/tree/tree");
const form_field_1 = require("./form-field");
exports.FormTree = (0, form_field_1.formFieldFactory)(tree_1.Tree);
//# sourceMappingURL=form-tree.js.map